import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { Button } from '@tencent/spaui';
import { Toolbar as PTPToolbar } from '@tencent/ptp-fe-common';
import './assets/less/index.less';

export interface BatchToolbarButton {
  /**
   * Key
   */
  key: string;
  /**
   * 名称
   */
  name: string;
  /**
   * 点击事件
   */
  onClick: () => void;
}

export interface BatchToolbarProps {
  /**
   * 是否显示
   */
  show?: boolean;
  /**
   * 组件类名
   */
  className?: string;
  /**
   * 左侧按钮列表
   */
  buttonList: (BatchToolbarButton | any)[];
  /**
   * 选择列表
   */
  selectedList: any[];
  /**
   * 选择提示文案
   */
  selectedLabel?: string;
  /**
   * 选择列表
   */
  onClose?: () => void;
}

export const BatchToolbar: React.FC<BatchToolbarProps> = (props) => {
  const { show, className, buttonList = [], selectedList = [], selectedLabel = '个账户', onClose } = props;

  const isSelected = selectedList.length > 0;


  const leftFixer = (
    <>
      已选择<span className="select-keys-count"> {selectedList.length} </span>{selectedLabel}
    </>
  );

  const leftElement = _.filter(buttonList, (v) => v).map((v) => {
    const { key, name, onClick, ...other } = v;
    return  <Button key={v.key} displayType="link" className="borderless button-mass-more" tip={!isSelected ? '请勾选账户' : null} OverlayTriggerProps={{ placement: 'top' }} disabled={!isSelected} onClick={v.onClick} {...other}>
        {v.name}
      </Button>;
  });

  return show ? <PTPToolbar type="mass" className={classNames('batch-toolbar', className)} leftFixer={leftFixer} left={leftElement} clear={true} onClose={onClose} /> : null;
};

BatchToolbar.defaultProps = {
  buttonList: [],
  selectedList: [],
  show: false,
  onClose: () => {},
};

export default BatchToolbar;
